// extracted by mini-css-extract-plugin
export var inner = "Header-module--inner--Vg76d";
export var root = "Header-module--root--V5ReS";